export const cardData = [
  {
    icon: "/services-icons/medical-billing.webp",
    title: "Medical Billing",
    description: "Improve claim accuracy, reduce delays, and keep reimbursement workflows moving.",
    href: "/services/medical-billing",
  },
  {
    icon: "/services-icons/denial-management.webp",
    title: "Denial Management",
    description: "Recover revenue with organized appeal handling and denial follow-up support.",
    href: "/services/denial-management",
  },
  {
    icon: "/services-icons/credentialing-and-enrollment.webp",
    title: "Credentialing & Enrollment",
    description: "Keep provider records, payer enrollments, and recredentialing tasks on track.",
    href: "/services/credentialing-and-enrollment",
  },
  {
    icon: "/services-icons/account-receivable.webp",
    title: "Account Receivables",
    description: "Strengthen cash flow with aging claim follow-up and structured AR recovery.",
    href: "/services/account-receivables",
  },
  {
    icon: "/services-icons/prior-authorization.webp",
    title: "Prior Authorization",
    description: "Support faster approvals with accurate submission tracking and payer coordination.",
    href: "/services/prior-authorization",
  },
  {
    icon: "/services-icons/eligibility-verification.webp",
    title: "Verification of Benefits",
    description: "Confirm coverage details early for cleaner intake and more accurate billing.",
    href: "/services/verification-of-benefits",
  },
  {
    icon: "/services-icons/virtual-medical-scribe.webp",
    title: "Virtual Medical Scribe",
    description: "Reduce charting pressure with remote documentation support for providers.",
    href: "/services/virtual-medical-scribe",
  },
  {
    icon: "/services-icons/virtual-assistant.webp",
    title: "Virtual Assistant",
    description: "Extend your team with reliable scheduling and administrative support coverage.",
    href: "/services/virtual-assistant",
  },
];
